export const VCON = 'VCON';
export const CCON = 'CCON';